import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RowColLayout from "../../components/RowColLayout";
import FormField from "../../components/FormField";
import MyButton from "../../components/MyButton";
import logo from '../../assets/images/logos/copa_logo_white.png';
import pass from '../../assets/icons/small_icons/contrasena.svg';
import franjasup from '../../assets/images/logos/franjaSup.svg';
import franjainf from '../../assets/images/logos/franjaInf.svg';
import CenteredColumnLayout from '../../components/CenteredColumnLayout';
import LiquidContainer from "../../components/LiquidContainer";
import { resetPassword } from "../../api/user";

export default function ResetPassword() {
  // 1. Get UID and Token from the URL link sent by email
  const { uid, token } = useParams();
  const navigate = useNavigate();

  // --- States ---
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // --- Handler ---
  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      // 2. Call the backend with the new password + tokens
      await resetPassword({ 
        uid: uid, 
        token: token, 
        new_password: newPassword 
      });
      
      alert("¡Contraseña actualizada con éxito!");
      navigate("/"); // Redirect to login page
    } catch (err) {
      setError(err.response?.data?.error || "El enlace ha expirado o es inválido.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='container-fluid d-flex flex-column justify-content-between m-0 p-0' 
      style={{
        minHeight: '100vh',
        backgroundImage: "url('/static/images/backLogin.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>

      <RowColLayout />

      {/* Top Graphic */}
      <div className="row m-0 p-0" style={{ height: "7vh" }}>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100 m-0 p-0">
          <img src={franjasup} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "right top" }} />
        </div>
      </div>

      <CenteredColumnLayout>
        <img src={logo} style={{ maxHeight: "26vh", maxWidth: "210px" }} alt="Logo" />
      </CenteredColumnLayout>

      <CenteredColumnLayout>
        <LiquidContainer>
          <div className="signin w-100 m-0 px-4 py-5">
            <h2 className="text-center text-black mb-4">Ingresar nueva contraseña</h2>
            
            <form onSubmit={handleResetSubmit} className="d-flex flex-column justify-content-center align-items-center">
              <FormField
                label="Nueva contraseña"
                name="newPassword"
                type="password"
                placeholder="Escribe tu nueva contraseña"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                icon={pass}
              />

              <FormField
                label="Confirmar contraseña"
                name="confirmPassword"
                type="password"
                placeholder="Repite tu contraseña"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                icon={pass}
              />

              <div className="d-flex flex-column justify-content-center align-items-center mt-4" style={{ width: "70%" }}>
                <MyButton 
                    text={loading ? "Actualizando..." : "Cambiar Contraseña"} 
                    type="submit" 
                    disabled={loading}
                />
                <p 
                  className="mt-3 text-black" 
                  style={{ cursor: 'pointer', textDecoration: 'underline' }} 
                  onClick={() => navigate("/")}
                >
                  Volver al Login
                </p>
              </div>
            </form>
          </div>
        </LiquidContainer>
      </CenteredColumnLayout>

      {/* Error Message Section */}
      <RowColLayout>
        {error && (
          <div className="alert alert-danger text-center mt-1" role="alert">
            {error}
          </div>
        )}
      </RowColLayout>

      {/* Bottom Graphic */}
      <div className="row m-0 p-0" style={{ height: "7vh" }}>
        <div className="col-4 h-100 m-0 p-0">
          <img src={franjainf} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left bottom" }} />
        </div>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100"></div>
      </div>
      
      <RowColLayout />
    </div>
  );
}